import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { useMergeRefs } from '@/js/libs/hooks/useMergeRefs';
import { Input } from '../../Input';
import { DATE_PICKER_REF } from '../constants';
export const DatePickerInput = memo(forwardRef(function DatePickerInput({ [DATE_PICKER_REF]: datePickerRef, ...props }, ref) {
    const mergedRef = useMergeRefs(datePickerRef, ref);
    return _jsx(Input, { ref: mergedRef, ...props });
}));
